import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { analyticsApi } from '../services/api';

export interface TodayAnalytics {
  totalIssued: number;
  waiting: number;
  serving: number;
  completed: number;
  noShow: number;
  cancelled: number;
  avgWaitMinutes: number;
  avgServeMinutes: number;
  noShowRate: number;
  hourlyDistribution: number[];
}

interface DashboardState {
  todayData: TodayAnalytics | null;
  isLoading: boolean;
  hasFetched: boolean;

  fetchTodayData: () => Promise<void>;
}

export const useDashboardStore = create<DashboardState>()(
  persist(
    (set, get) => ({
      todayData: null,
      isLoading: false,
      hasFetched: false,

      fetchTodayData: async () => {
        const state = get();
        if (!state.hasFetched) {
          set({ isLoading: true });
        }

        try {
          const response = await analyticsApi.today();
          set({
            todayData: response.data,
            isLoading: false,
            hasFetched: true,
          });
        } catch (error: any) {
          console.error('Failed to fetch today analytics:', error);
          set({ isLoading: false, hasFetched: true });
        }
      },
    }),
    {
      name: 'dashboard-storage',
      partialize: (state) => ({
        todayData: state.todayData,
        hasFetched: state.hasFetched,
      }),
    }
  )
);
